
<form id="scrn-c" [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword(resetPasswordForm.value)" novalidate="novalidate">

  <h2 *ngIf="templateSettings.headerLegend" class="legend">{{ locale.changePasswordHeaderText }}</h2>

  <ng-container *ngIf="showMessagesTop">
    <div *ngIf="changePasswordMessage" class="alert">{{ changePasswordMessage }}</div>
    <div *ngIf="messageCopy" class="{{ messageClass }}" role="Message">{{ messageCopy }}</div>
  </ng-container>

  <div class="column">


    <div class="form-control">
      <label for="currentPassword">{{locale.currentPasswordPlaceholder}}</label>
      <input (click)="onClickInput()" type="{{currentPasswordType}}" class="input-control show-pad" (keyup)="validate()" [formControl]="resetPasswordForm.controls['currentPassword']"/>
      <div class="validation-error" *ngIf="(resetPasswordSubmitted || resetPasswordForm.controls['currentPassword'].dirty) && !resetPasswordForm.controls['currentPassword'].valid">
        <div class="form-hint">
          <div>{{locale.currentPasswordValidation | stringFormat : [this.passwordLength]}}</div>
        </div>
      </div>
      <span><a (click)="toggleCurrentPassword()">{{showCurrentPassword ? locale.hidePasswordText : locale.showPasswordText}}</a></span>
    </div>

  <div class="form-control">
    <label for="password">{{locale.passwordPlaceholder}}</label>
    <input (click)="onClickInput()" type="{{passwordType}}" class="input-control show-pad" (keyup)="validate()" [formControl]="resetPasswordForm.controls['password']"/>
    <div class="validation-error" *ngIf="(resetPasswordSubmitted || resetPasswordForm.controls['password'].dirty) && !resetPasswordForm.controls['password'].valid">
      <div class="form-hint">
        <div>{{locale.passwordValidationText | stringFormat : [this.passwordLength]}}</div>
      </div>
    </div>
    <span><a (click)="togglePassword()">{{showPassword ? locale.hidePasswordText : locale.showPasswordText}}</a></span>
  </div>

  <div class="form-control">
    <label for="password">{{locale.confirmNewPasswordPlaceholder}}</label>
    <input (click)="onClickInput()" type="{{confirmPasswordType}}" class="input-control show-pad" validateEqual="password" [formControl]="resetPasswordForm.controls['passwordConfirmation']" />
    <div class="validation-error" *ngIf="(resetPasswordSubmitted || resetPasswordForm.controls['passwordConfirmation'].dirty) && !resetPasswordForm.controls['passwordConfirmation'].valid">
      <div class="form-hint">
        <div>{{locale.confirmNewPasswordValidationText | stringFormat : [this.passwordLength]}}</div>
      </div>
    </div>
    <span><a (click)="toggleConfirmPassword()">{{showConfirmPassword ? locale.hidePasswordText : locale.showPasswordText}}</a></span>
  </div>

  <ng-container *ngIf="templateSettings.showMessagesBottom">
    <div *ngIf="messageCopy" class="{{ messageClass }} message" role="Message">{{ messageCopy }}</div>
  </ng-container>

  <div class="form-control">
    <ng-container *ngIf="changePasswordMessage; else updatePasswordButton" >
    <button type="submit" class="input-control button" [disabled]="formSubmitted">{{locale.changePasswordButtonText}}</button>
    </ng-container>
    <ng-template #updatePasswordButton>
    <button type="submit" class="input-control button" [disabled]="formSubmitted">{{locale.updatePasswordButtonText}}</button>
    </ng-template>
  </div>

  </div>

</form>




// WEBPACK FOOTER //
// ./src/app/components/_shared/account/base-manage-password/base-manage-password.component.html